import React, { useEffect, useState } from "react";
import axios from "axios";
import EditItemModal from "../modals/EditItemModal";
import { format, eachDayOfInterval } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const CommuteModal = ({ isOpen, onClose, onSave, subTripId, parentTripId }) => {
  const [commuteItems, setCommuteItems] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [range] = useState([{ startDate: new Date(), endDate: new Date(), key: "selection" }]);
  const [place, setPlace] = useState("");
  const [details, setDetails] = useState("");
  const [cost, setCost] = useState("");
  const [url, setUrl] = useState("");
  const [setShowCreateSubTrip] = useState(false);
  const [setMissingDate] = useState(null);
  const [setIsAdding] = useState(false);

  useEffect(() => {
    if (isOpen && subTripId) {
      loadCommuteItems();
    }
  }, [isOpen, subTripId]);

	useEffect(() => {
	  if (isOpen && parentTripId) {
		loadCommuteItems();
	  }
	}, [isOpen, parentTripId]);

	const loadCommuteItems = async () => {
	  try {
		const res = await axios.get(`${process.env.REACT_APP_API_URL}/subtripitems/trip/${parentTripId}/commute_items`, {
		  headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		  },
		});
		setCommuteItems(res.data);
	  } catch (error) {
		console.error("Failed to load commute items", error);
	  }
	};


  // 開啟編輯
  const handleEditClick = (item) => {
    setEditingItem(item);
    setEditedData({ ...item });
  };

  // 更新表單欄位
  const handleFieldChange = (field, value) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // 儲存修改
  const handleSaveEdit = async () => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/subtripitems/sub_trip/item/${editingItem.id}`,
        editedData
      );
      setEditingItem(null);
      loadCommuteItems();
	  setPlace("");
	  setDetails("");
	  setCost("");
	  setUrl("");
    } catch (error) {
      console.error("Failed to update item", error);
    }
  };

  const handleCancelEdit = () => {
    setEditingItem(null);
    setEditedData({});
  };

	const handleAddCommute = async () => {
		setIsAdding(true);
	  if (!place || !range[0]?.startDate || !range[0]?.endDate) {
		alert("Please fill in the place and select date range.");
		return;
	  }		
	  const startDate = range[0].startDate;
	  const endDate = range[0].endDate;
	  const dates = eachDayOfInterval({ start: startDate, end: endDate });

	  const addCommuteForDates = async (dateList) => {
		for (const date of dateList) {
		  const formattedDate = format(date, "yyyy-MM-dd");

		  try {
			const res = await axios.get(
			  `${process.env.REACT_APP_API_URL}/subtripitems/sub_trip/date/${parentTripId}`,
			  {
				params: { date: formattedDate },
			  }
			);
			const subTrip = res.data;

			const itemsRes = await axios.get(
			  `${process.env.REACT_APP_API_URL}/subtripitems/sub_trip/${subTrip.id}/items`
			);
			const exists = itemsRes.data.some(
			  (item) => item.date === formattedDate && item.type === "commute"
			);

			if (exists) continue;

			await axios.post(
			  `${process.env.REACT_APP_API_URL}/subtripitems/sub_trip/${subTrip.id}/item`,
			  {
				date: formattedDate,
				place,
				type: "commute",
				details,
				cost,
				url,
			  }
			);
		  } catch (err) {
			if (err.response && err.response.status === 404) {
			  // 某一天缺 subTrip
			  setMissingDate(formattedDate);
			  setShowCreateSubTrip(true);
			  return; // 暫停流程，等待用戶建立 subtrip
			} else {
			  console.error("Error adding commute:", err);
			}
		  }
		}

		loadCommuteItems();
		setPlace("");
		setDetails("");
		setCost("");
		setUrl("");
	  };

	  await addCommuteForDates(dates);
	  setIsAdding(false);
	};

  if (!isOpen) return null;

	return (
	  <div className="modal-content responsive-container">
		<h2 className="heading mb-4 text-primary">Transportation Details</h2>
		<ul className="space-y-3 mb-6">
		  {commuteItems.map((item) => (
			<li
			  key={item.id}
			  className="border border-accent p-4 rounded-md cursor-pointer hover:bg-yellow-50"
			  onClick={() => handleEditClick(item)}
			>
			  <div className="font-semibold text-base sm:text-lg">{item.place}</div>
			  <div className="text-sm text-gray-500">{item.date}</div>
			  <div className="text-sm">{item.details}</div>
			  {item.cost && (
				<div className="text-sm text-gray-600">Cost: ${item.cost}</div>
			  )}
			  {item.url && (
				<a
				  href={item.url}
				  className="text-blue-500 text-sm underline"
				  target="_blank"
				  rel="noopener noreferrer"
				  onClick={(e) => e.stopPropagation()} 
				>
				  More Info
				</a>
			  )}
			</li>
		  ))}
		</ul>

		{/* 這裡可以選擇保留關閉按鈕，或刪除（Modal 元件已處理） */}
		{/* <div className="text-right pt-4">
		  <button
			className="px-4 py-2 bg-accent text-white rounded hover:bg-yellow-600"
			onClick={onClose}
		  >
			Close
		  </button>
		</div> */}

		{editingItem && (
		  <EditItemModal
			isOpen={!!editingItem}
			itemData={editedData}
			onChange={handleFieldChange}
			onClose={handleCancelEdit}
			onSave={handleSaveEdit}
		  />
		)}
	  </div>
	);
};

export default CommuteModal;
